var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBook = function SvgIconBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.5 4.5A1.5 1.5 0 0 0 6 6v9.401A3 3 0 0 1 7.5 15H18V4.5zm10.5 12H7.5a1.5 1.5 0 0 0 0 3H18zM4.5 18V6a3 3 0 0 1 3-3h11.25l.75.75V21h-12a3 3 0 0 1-3-3",
    clipRule: "evenodd"
  })));
};
export default SvgIconBook;